import React from 'react';

import { graphql, withApollo } from 'react-apollo';
import _ from 'lodash';
import { Tooltip, Select, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import getCategorias from '../../../graphql/querys/editor/getCategoriasConModelos.graphql';
import getCategoriaPorId from '../../../graphql/querys/editor/getCategoriaPorId.graphql';

import Loading from '../../common/Loading';

const FormItem = Form.Item;
const Option = Select.Option;

class SelectorModelo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      desabilitado: true,
      modelos_notas: [],
    };

    // this.handleChange = this.handleChange.bind(this);
    this.crearOpciones = this.crearOpciones.bind(this);
    this.filtrarNotas = this.filtrarNotas.bind(this);
  }

  crearOpciones(categoria) {
    return (
      <Option key={categoria._id} value={categoria._id}>
        {categoria.nombre}
      </Option>
    );
  }

  filtrarNotas(categoria) {
    // console.log("recibi... ", categoria);

    this.props.client
      .query({
        query: getCategoriaPorId,
        variables: { idCategoria: categoria },
      })
      .then(respuesta => {
        // console.log("Recibi de respuesta...", respuesta);
        let categoria = respuesta.data.getCategoriaPorId;
        let modelos_notas = categoria.modelos_notas;

        this.setState({
          modelos_notas,
          desabilitado: false,
        });
      });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("Los valores son ", values);

        this.props.onSubmit(values);
      }
    });
  };

  // handleChange(value) {
  //     console.log(`selected ${value}`);
  //     this.props.handleChange(value); //le envio los datos al padre
  // }

  render() {
    // let listaModelosNotas = this.props.data.getModelosNotasFiltradas;
    const { getFieldDecorator } = this.props.form;
    let listaCategoras = this.props.data.getCategorias;

    // if (listaModelosNotas) {
    //   var opciones = _.map(listaModelosNotas, this.crearOpciones);
    // }

    var opcionesCategorias = [];
    if (listaCategoras) {
      opcionesCategorias = _.map(
        _.orderBy(listaCategoras, ['nombre'], ['asc']),
        this.crearOpciones
      );
    }

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    if (this.props.data.loading) {
      return <Loading />;
    }

    return (
      <div>
        <h1 className="tituloForm">Seleccion de Nota Modelo</h1>
        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Categoria del Modelo de Nota
                <Tooltip title="Seleccione la Categoria del modelo de nota">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('categoria', {
              rules: [
                { required: true, message: 'Por favor, ingrese la categoria!' },
              ],
            })(
              <Select
                showSearch
                style={{ width: 500 }}
                placeholder="Seleccione una categoria"
                optionFilterProp="children"
                onChange={this.filtrarNotas}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opcionesCategorias}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Modelo nota a utilizar
                <Tooltip title="Seleccione el modelo nota que quiere usar para generar el archivo.  Si no puede seleccionar ninguno, se debe a que su organismo no tiene ninguno configurado">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('modelo', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el modelo de nota!',
                  whitespace: true,
                },
              ],
            })(
              <Select
                showSearch
                style={{ width: 500 }}
                placeholder="Seleccione un modelo"
                optionFilterProp="children"
                onChange={this.props.handleChange}
                disabled={
                  this.state.desabilitado ||
                  this.state.modelos_notas.length == 0
                }
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {this.state.modelos_notas &&
                  this.state.modelos_notas.map(modelo => (
                    <Option key={modelo._id} value={modelo._id}>
                      {modelo.titulo}
                    </Option>
                  ))}
              </Select>
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Siguiente
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(
  withApollo(graphql(getCategorias)(SelectorModelo))
);
